const countryView = {
  en: {
    countryHeadline:
      "Our global network is accepted in more than 185 countries and territories",
    countryHeadlineCopy: "Explore where your card is accepted.",
    countryHeadlineFootnote:
      "Internal Discover Transaction Data, leveraging the average of transaction data from 2023-2025",
    countryHeadlineFootnoteAdditional:
      "Based on DFS Services LLC Internal Data and Third Party reporting as of December 2025",
    travelHeadline: "Travel with confidence wherever you go",
    travelHeadlineCopy:
      "Your card is accepted at millions of places around the world. From dining, shopping, and exploring, look for the Diners Club and Discover acceptance marks on the back of your card to appear at checkout.",
    regionSquares: {
      asiaPacific: {
        headline: "Asia Pacific",
        description:
          "Japan, India, China, Singapore, Australia, and other destinations across Asia and the Pacific Islands are a part of a global network that includes Discover Network and Diners Club. So if you're headed that way, be sure to bring your card.",
      },
      europe: {
        headline: "Europe",
        description:
          "Whether you're visiting just one country, or traveling your way through Europe, your card is ready to go. It's accepted in so many popular European destinations, including Spain, Germany, the UK, Italy, Portugal and France.",
      },
      middleEastAfrica: {
        headline: "Middle East & Africa",
        description:
          "When exploring the Middle East and Africa, you can use your card in UAE, Egypt, Morocco and South Africa. With acceptance in other countries expanding rapidly, you can use your card in more and more places here.",
      },
      americas: {
        headline: "The Americas",
        description:
          "Use your card in many places throughout the United States. Plus, your card is accepted in Canada, Mexico and popular travel spots in South America like Peru, Uruguay, Argentina, Chile and more.",
      },
    },
    featuredMerchants: "Featured Merchants",
    nilson: "According to the Feb 2026 issue of the Nilson Report.",
    placement: {
      headline: "Ready to see all the places your card can take you?",
      cta: "Explore Card Acceptance",
    },
  },
  es: {
    countryHeadline:
      "Nuestra red global es aceptada en más de 185 países y territorios",
    countryHeadlineCopy: "Explorá dónde se acepta tu tarjeta.",
    countryHeadlineFootnote:
      "Datos internos de Discover Transaction Data, utilizando el promedio de datos de transacciones de 2023-2026",
    countryHeadlineFootnoteAdditional:
      "Según los datos internos de DFS Services LLC y los informes de terceros como de diciembre de 2025",
    travelHeadline: "Viaja con confianza dondequiera que vayas",
    travelHeadlineCopy:
      "Tu tarjeta es aceptada en millones de lugares alrededor del mundo. Desde comer, comprar y explorar, busca los signos de aceptación de Diners Club y Discover en el reverso de tu tarjeta para aparecer al momento de pagar.",
    regionSquares: {
      asiaPacific: {
        headline: "Asia Pacífico",
        description:
          "Japón, India, China, Singapur, Australia y otros destinos en Asia y las Islas del Pacífico forman parte de una red global que incluye Discover Network y Diners Club. Así que si te diriges hacia allá, no olvides llevar tu tarjeta.",
      },
      europe: {
        headline: "Europa",
        description:
          "Ya sea que visites un solo país o recorras Europa, tu tarjeta está lista. Es aceptada en muchos destinos europeos populares, como España, Alemania, el Reino Unido, Italia, Portugal y Francia.",
      },
      middleEastAfrica: {
        headline: "Medio Oriente y África",
        description:
          "Al explorar Medio Oriente y África, puedes usar tu tarjeta en EAU, Egipto, Marruecos y Sudáfrica. Con la aceptación en otros países expandiéndose rápidamente, puedes usar tu tarjeta en cada vez más lugares.",
      },
      americas: {
        headline: "América",
        description:
          "Usa tu tarjeta en muchos lugares de los Estados Unidos. Además, tu tarjeta es aceptada en Canadá, México y destinos populares de América del Sur como Perú, Uruguay, Argentina, Chile y más.",
      },
    },
    featuredMerchants: "Comercios destacados",
    nilson: "Según la edición de febrero de 2026 del Informe Nilson.",
    placement: {
      headline:
        "¿Listo para ver todos los lugares donde tu tarjeta puede llevarte?",
      cta: "Explorar Aceptación de Tarjeta",
    },
  },
};

export default countryView;
